module.exports = __webpack_public_path__ + "img/social.c923807c.png";